import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-id"]
const _hoisted_2 = { class: "as-match__time" }
const _hoisted_3 = { class: "as-match__label-item" }
const _hoisted_4 = { class: "as-match__teams" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "as-match__team--name as-match__team-home-name" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "as-match__team--name as-match__team-away-name" }
const _hoisted_11 = {
  key: 1,
  class: "as-match__play"
}
const _hoisted_12 = { class: "as-match__round" }
const _hoisted_13 = {
  key: 0,
  class: "as-match__label-item"
}

import { computed, ref } from "vue";
import type { IMatch, IItemString, IRound } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getRoundName } from "~src/helpers";
import { getOddValue } from "~src/helpers/OddHelper";
import IconPlay from "~src/components/icons/IconPlay.vue";
import ScoreVs from "~src/components/matches/ScoreVs.vue";


const __default__ = {};

interface IProps {
  match: IMatch;
  competitionType: any;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MatchItem',
  props: {
    match: {},
    competitionType: {}
  },
  emits: ['itemClicked'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const roundName = computed(() => {
  return getRoundName(props.match, props.competitionType);
});

const showLinkStream = (match: IMatch) => {
  emit('itemClicked', match, true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "as-match__item",
    "data-id": _ctx.match.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(formatLocalTime)(_ctx.match.match_time, "h:mm DD/MM")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: _ctx.getLinkTeamDetail(_ctx.match.home_team?.id),
        class: "as-match__team as-match__team--home"
      }, [
        _createElementVNode("img", {
          src: _ctx.getImgUrlBySport('team', _ctx.match.home_team?.id),
          alt: _ctx.match.home_team?.name,
          class: "as-match__team--logo"
        }, null, 8, _hoisted_6),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.match.home_team?.name), 1)
      ], 8, _hoisted_5),
      _createVNode(ScoreVs, {
        match: _ctx.match,
        size: 28
      }, null, 8, ["match"]),
      _createElementVNode("a", {
        href: _ctx.getLinkTeamDetail(_ctx.match.away_team?.id),
        class: "as-match__team as-match__team--away"
      }, [
        _createElementVNode("img", {
          src: _ctx.getImgUrlBySport('team', _ctx.match.away_team?.id),
          alt: _ctx.match.away_team?.name,
          class: "as-match__team--logo"
        }, null, 8, _hoisted_9),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.match.away_team?.name), 1)
      ], 8, _hoisted_8)
    ]),
    (_ctx.match.match_live_item)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "as-match__play",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showLinkStream(_ctx.match))),
          role: "button",
          type: "button"
        }, [
          _createVNode(IconPlay, { fill: "#c72a1d" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11)),
    _createElementVNode("div", _hoisted_12, [
      (roundName.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(roundName.value), 1))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}
}

})